import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import UserAvatar from '../../../User/Avatar';
import UserLink from '../../../User/Link';
import s from './Attribution.scss';
const Attribution = ({ author, relatedItemBiData, className, avatarSize = 25, showAvatar = true, showAuthorTooltip, showAuthorName = true, userlinkClassName })=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['attribution'], !showAvatar && s['no-avatar'], className)
    }, author && /*#__PURE__*/ React.createElement(React.Fragment, null, showAvatar && /*#__PURE__*/ React.createElement(UserAvatar, {
        size: avatarSize,
        className: s['avatar'],
        user: author,
        withTooltip: showAuthorTooltip,
        relatedItemBiData: relatedItemBiData,
        "aria-label": author.username
    }), !showAvatar && /*#__PURE__*/ React.createElement(React.Fragment, null, t('deviationview.overlay.by'), "\xa0"), showAuthorName && /*#__PURE__*/ React.createElement(UserLink, {
        className: classnames(s['user-link'], userlinkClassName),
        user: author,
        withTooltip: showAuthorTooltip,
        biData: {
            creatorid: author.useridUuid
        },
        relatedItemBiData: relatedItemBiData
    })));
};
Attribution.displayName = 'Attribution';
export default Attribution;
